import React, { useMemo } from 'react';

import { StyledImageBox, Inner, Align } from './wrappers';
import { Breakpoint } from '../layout/theme';

export type BreakpointSize = { height: number; width: number } | number;
export type BreakpointSizes = Partial<Record<Breakpoint, BreakpointSize>>;

interface IImageBox {
  align?: 'left' | 'center' | 'right';
  alignLtSm?: 'left' | 'center' | 'right';
  children: React.ReactNode;
  width?: string;
  height?: string;
  ratio?: number;
  breakpointSizes?: BreakpointSizes;
}

const alignMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
} as Record<string, Align>;

const ImageBox = ({
  align = 'center',
  alignLtSm,
  children,
  width,
  height,
  ratio,
  breakpointSizes,
}: IImageBox) => {
  const styling = useMemo(
    () => ({
      paddingBottom: ratio ? `${ratio * 100}%` : 'initial',
    }),
    [ratio],
  );

  return (
    <StyledImageBox
      boxWidth={width}
      boxHeight={height}
      breakpointSizes={breakpointSizes}
      style={styling}>
      <Inner align={alignMap[align]} alignLtSm={alignMap[alignLtSm || align]}>
        {children}
      </Inner>
    </StyledImageBox>
  );
};

export default ImageBox;
